export default "__VITE_ASSET__CWVtSJ3d__"